<template>
  <div
    v-if="hasOutfitKeys"
    class="product-shoppable-outfits critical-component-clear"
  >
    <div
      v-if="isMobile"
      id="shop-the-look"
      class="
        main-product__shop-the-look-wrapper
        main-product__shop-the-look-wrapper--mobile
      "
    >
      <product-outfits
        :current-index="currentIndex"
        :outfit-keys="outfitKeys"
        :product="product"
        @update-current-index="handleUpdateCurrentIndex"
      />
    </div>

    <div
      v-else
      id="shop-the-look"
      class="main-product__shop-the-look-container grid"
    >
      <div
        class="
          main-product__shop-the-look-wrapper
          main-product__shop-the-look-wrapper--desktop
          col xs-span"
        :class="stlGridClass"
      >
        <product-outfits
          :current-index="currentIndex"
          :outfit-keys="outfitKeys"
          :product="product"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product shoppable outfits (product-shoppable-outfits)
 * -----------------------------------------------------------------------------
 * Product Shoppable Outfits Section.
 *
 *
 */

// eslint-disable-next-line import/named
import { mapState } from 'vuex'
import ProductOutfits from '~async/product-outfits/product-outfits.vue'

export default {
  name: 'ProductShoppableOutfits',
  components: {
    ProductOutfits,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      currentIndex: 0,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute the product images' outfit keys.
     * - Computed here to determine if STL component should be rendered.
     * @returns {Array}
     */
    outfitKeys() {
      return this.product?.media
        ?.map((media) => {
          if (!media.raw_alt) {
            return null
          }

          const firstSplit = media.raw_alt.split('{{ outfit:')
          const secondSplit = firstSplit?.[1]?.split(' }}')

          if (!secondSplit?.[1]) {
            return null
          }

          return secondSplit[0].trim()
        })
    },

    /**
     * Computes if product has outfit keys.
     * @returns {Boolean}
     */
    hasOutfitKeys() {
      return this.outfitKeys?.filter(Boolean)?.length ?? false
    },
  },

  created() {
    window.cnvs.EventBus.listen('pdp:current-index-updated', (newIndex) => {
      this.currentIndex = newIndex
    })
  },
}
</script>

<style lang="scss">
@import './product-shoppable-outfits';
</style>
